import { Button, Modal, Space, message } from 'antd'
import React, { createContext } from 'react'
import { deleteHouse } from '../../../../api/api'
const ReachableContext = createContext(null)
const UnreachableContext = createContext(null)

const DeleteModal = (props) => {
  const config = {
    title: '确定删除此房源吗？删除后不可恢复',
    okText: '确定',
    cancelText: '取消',
    onOk: () => {
      console.log("删除：",props.id);
      deleteHouse(props.id).then((res) => {
        message.success('删除房源成功！')
        props.setData((pre) => {
          const newData = pre.filter((item) => item.id !== props.id)
          return newData
        })
      }).catch(err => {
          console.warn(err);
          message.error('删除房源失败！')
      })
    },
  }
  const [modal, contextHolder] = Modal.useModal()

  return (
    <ReachableContext.Provider value="Light">
      <Space>
        <a
          onClick={() => {
            modal.confirm(config)
          }}
        >
          删除
        </a>
      </Space>
      {/* `contextHolder` should always be placed under the context you want to access */}
      {contextHolder}

      {/* Can not access this context since `contextHolder` is not in it */}
      <UnreachableContext.Provider  />
    </ReachableContext.Provider>
  )
}
export default DeleteModal
